import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ShieldCheck, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav("/admin");
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido de nuevo");
      nav("/admin");
    } catch (e) {
      toast.error(apiErr(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B132B] flex items-center justify-center px-4 ej-grain relative">
      <Link to="/" data-testid="login-back-link" className="absolute top-6 left-6 flex items-center gap-2 text-slate-400 hover:text-white text-sm">
        <ArrowLeft size={16} /> Volver al sitio
      </Link>
      <div className="w-full max-w-md relative z-10">
        <div className="text-center mb-8">
          <div className="text-3xl font-head font-extrabold">europe<span className="text-[#FFD166]">jobs</span></div>
          <div className="flex items-center justify-center gap-2 text-slate-400 text-sm mt-2">
            <ShieldCheck size={16} className="text-[#FFD166]" /> Portal de Administración
          </div>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="bg-[#1C2541] rounded-3xl border border-white/10 shadow-2xl p-8 space-y-5">
          <div>
            <label className="block text-sm font-medium text-slate-200 mb-1.5">Correo</label>
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#0B132B] border border-white/12 rounded-xl px-4 py-3 text-sm text-white focus:outline-none focus:border-[#FFD166]/60"
              placeholder="jorge@europejobs.pro" />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-200 mb-1.5">Contraseña</label>
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#0B132B] border border-white/12 rounded-xl px-4 py-3 text-sm text-white focus:outline-none focus:border-[#FFD166]/60"
              placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-[#FFD166] text-[#0B132B] font-bold py-3.5 rounded-full hover:bg-[#E0A926] transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
            {loading && <Loader2 className="animate-spin" size={18} />} Iniciar sesión
          </button>
        </form>
      </div>
    </div>
  );
}
